import script from "./DocLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./DocLibrary.vue?vue&type=script&setup=true&lang=js"

import "./DocLibrary.vue?vue&type=style&index=0&id=59f1b3d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f1b3d5"]])

export default __exports__